import { styled } from '@linaria/react'
import { DefaultButton, TextButton } from '../common'
import { useModal } from '@ebay/nice-modal-react'
import WalletManagementModal from '../wallet-management/wallet-management-modal'

const Container = styled.div`
  padding-bottom: 20px;
  .theme-dark & {
    border-bottom: 1px solid #1f223c;
  }
  .theme-light & {
    border-bottom: 1px solid #f5f6f9;
  }
`

type DepositWithdrawProps = {
  closeProfileDrawer: () => void
}

const DepositWithdraw = ({
  closeProfileDrawer: closeModal,
}: DepositWithdrawProps) => {
  const walletManagement = useModal(WalletManagementModal)
  return (
    <Container className="v-flx-ctr">
      <DefaultButton
        width={200}
        variant="blue"
        size="large"
        onClick={() => {
          walletManagement.show({ walletManagementDefaultTab: { tab: 0 }})
          closeModal()
        }}>
        Depósito
      </DefaultButton>
      <TextButton
        variant="blue"
        size="large"
        onClick={() => {
          walletManagement.show({ walletManagementDefaultTab: { tab: 1 }})
          closeModal()
        }}>
        Retirar
      </TextButton>
    </Container>
  )
}

export default DepositWithdraw
